import axios from "axios";

const login_form = {
  namespaced: true,
  state() {
    return {
      is_owner_allowed: false,
      building_search_type: 0,
      building_search_word_count: null,
      info_acquired: false,
    }
  },
  mutations: {
    setData(state, data) {
      if (data[0].is_owner_allowed === 1) {
        state.is_owner_allowed = true;
      } else {
        state.is_owner_allowed = false;
      }
      state.building_search_type = data[0].building_search_type;
      state.building_search_word_count = data[0].building_search_word_count;
      state.info_acquired = true;
    },
    resetData(state) {
      state.is_owner_allowed = false;
      state.building_search_type = 0;
      state.building_search_word_count = null;
      state.info_acquired = false;
    },
    setInfoAcquired(state, value) {
      state.info_acquired = value;
    },
  },
  actions: {
    load({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        if (payload?.mccd === null) {
          commit('resetData');
          commit('setInfoAcquired', true);
          resolve(true);
        }
        if (payload?.register_entry && state.info_acquired) {
          resolve(true);
        } else {
          axios.get(`/api/management_companies/${payload.mccd}/settings`).then((response) => {
            if (response.data.data.length === 1) {
              commit('setData', response.data.data);
              resolve(true);
            } else {
              resolve(false);
            }
          }).catch(() => reject());
        }
      });
    },
  }
}

export default login_form
